var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYellowCrown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m18.53 19.24h-13.13c-0.15717 0.0014-0.3107-0.0473-0.43836-0.139-0.12765-0.0916-0.22279-0.2216-0.27164-0.371l-3.19-9.73c-0.04887-0.13991-0.054-0.29139-0.0147-0.43429 0.03929-0.1429 0.12116-0.27046 0.2347-0.36571 0.11214-0.09839 0.25141-0.16059 0.39953-0.17843 0.14811-0.01785 0.29817 0.00949 0.43047 0.07843l5.82 2.9 3-5.82c0.0692-0.11602 0.1673-0.2121 0.2847-0.27882 0.1175-0.06672 0.2502-0.1018 0.3853-0.1018s0.2678 0.03508 0.3853 0.1018c0.1174 0.06672 0.2155 0.1628 0.2847 0.27882l3 5.83 5.83-2.9c0.1308-0.0681 0.2791-0.09499 0.4255-0.07714s0.2839 0.07961 0.3945 0.17714c0.0957 0.10491 0.1597 0.23486 0.1845 0.37471s0.0094 0.28387-0.0445 0.41529l-3.26 9.72c-0.0471 0.1513-0.1415 0.2834-0.2693 0.377s-0.2823 0.1437-0.4407 0.143zm-12.53-1.5h12l2.51-7.49-4.87 2.42c-0.0872 0.0446-0.1824 0.0715-0.2801 0.079-0.0976 0.0076-0.1958-0.0044-0.2889-0.0351-0.093-0.0307-0.179-0.0795-0.253-0.1437s-0.1345-0.1424-0.178-0.2302l-2.64-5.18-2.63 5.18c-0.04352 0.0878-0.10404 0.166-0.17803 0.2302s-0.16 0.113-0.25302 0.1437-0.19121 0.0427-0.28888 0.0351c-0.09767-0.0075-0.19286-0.0344-0.28007-0.079l-4.89-2.45 2.52 7.52z",
    fill: "#fc0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYellowCrown);
export default __webpack_public_path__ + "static/media/yellow-crown.9e24f8e105c4b5735baa40f25fd32648.svg";
export { ForwardRef as ReactComponent };